// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"InputSearch_search-wrapper__U6IbC","search":"InputSearch_search__rVzIQ","icon-search":"InputSearch_icon-search__OP7v1","clear-btn":"InputSearch_clear-btn__Pk5vR"};